import request from '@/utils/request'
import { v2Host } from '@/config/host'

export function fetchTagList(params) {
  return request({
    url: `${v2Host}/tag/list`,
    method: 'get',
    params: params
  })
}
